import React from "react";
import { Modal, Button } from "antd";

const OneWalletCommonModal = ({
    isVisible,
    onClose,
    title,
    content,
    primaryAction,
    secondaryAction,
    primaryLabel = "OK",
    secondaryLabel = "Cancel",
    showSecondary = true, // Controls whether the secondary button is displayed
    showPrimary = true, // Controls whether the primary button is displayed
    modalWidth = 520, // Default width
}) => {
    console.log("OneWalletCommonModal",isVisible, onClose, title, content, primaryAction, secondaryAction, primaryLabel, secondaryLabel, showSecondary, showPrimary, modalWidth);
    return (
        <Modal
            visible={isVisible}
            onCancel={onClose}
            footer={null}
            centered
            title={title || null}
            className="one-wallet-common-modal"
            width={modalWidth}
        >
            {/* Call the function if content is a function */}
            <div>{typeof content === "function" ? content() : content}</div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                }}
            >
                {showSecondary && (
                    <Button className="secondaryBtn" onClick={secondaryAction}>
                        {secondaryLabel}
                    </Button>
                )}
                {showPrimary && (
                    <Button
                        type="primary"
                        className="singleBtn"
                        onClick={primaryAction}
                    >
                        {primaryLabel}
                    </Button>
                )}
            </div>
        </Modal>
    );
};

export default OneWalletCommonModal;
